/** Every category, in tab order: a row is a PRO whose accrued cost exceeds what was
 *  billed. Pre Pull and Stop Off (2026-10-30) are leg-cost categories like Chassis
 *  Split — the cost is the net driver pay on the legs the charge fires on — and also
 *  carry the invoice reconciler's figure for the charge as the Quoted Charge. */
export const CATEGORY_LABELS: Record<string, string> = {
  bobtail: 'Bobtail',
  waiting_time: 'Waiting Time',
  hazmat: 'Hazmat',
  chassis_split: 'Chassis Split',
  storage: 'Storage',
  per_diem: 'Per Diem',
  ssl_chassis: 'SSL Chassis Use',
  pre_pull: 'Pre Pull',
  stop_off: 'Stop Off',
};

/** Every tab, in tab order. */
export const ALL_CATEGORY_LABELS: Record<string, string> = CATEGORY_LABELS;

